import { render, staticRenderFns } from "./StudentDataTable.vue?vue&type=template&id=63cecc0e&scoped=true"
import script from "./StudentDataTable.vue?vue&type=script&lang=js"
export * from "./StudentDataTable.vue?vue&type=script&lang=js"
import style0 from "./StudentDataTable.vue?vue&type=style&index=0&id=63cecc0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cecc0e",
  null
  
)

export default component.exports